import {GetUserToken} from "./services";


const cleanInputUsername = (inData) => {
    let data = inData.replace(" ", "");
    data = data.toLocaleLowerCase();
    return data;
}

export  const isSupperAdminUser=async ()=>{
    let user = GetUserToken();
    const role = user.Role;
    if(role==="super"||role==="dealer"){
        //todo
    }else{
        alert("Sorry you can't perform this action,Your role is: "+role+"");
        window.location.href="#/home"
    }
}
export {cleanInputUsername};
